module.exports = {
    messages: {
        de: {
            mainToc: {
                overview: "Inhaltsübersicht"
            },
            transcriptToc: {
                contextWarning: "Hinweis: Die aktuelle Seite befindet sich nicht im Inhalt des gewählten Kontextes",
                noToc: "Kein Inhaltsverzeichnis im gewählten Kontext verfügbar",
                toc: "Inhalt"
            }
        },
        en: {
            mainToc: {
                overview: "Table of contents"
            },
            transcriptToc: {
                contextWarning: "Note: The current page is not listed in the table of contents of the currently selected context",
                noToc: "No table of contents available for the selected context",
                toc: "Table of contents"
            }
        },
        fr: {
            mainToc: {
                overview: "Table des matières"
            },
            transcriptToc: {
                contextWarning: "Avertissement: La page actuelle se ne trouve pas dans la table des matières du contexte choisi",
                noToc: "La table des matières n'est pas disponible pour le contexte choisi",
                toc: "Table des matières"
            }
        }
    }
}
